import { Component, ElementRef, Injector, OnInit, Optional, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GridColumnStyles, MyLog } from '@common/common';
import { DataService } from '@data/data.service';
import { CheckboxCellRendererComponent } from '@grid-cell/checkbox-cell-renderer.component';
import { CheckboxHeaderCellRendererComponent } from '@grid-cell/checkbox-header-cell-renderer.component';
import { getRowStyle, OrdersGridComponent } from '@grid/orders-grid/orders-grid.component';
import { NotificationService } from '@notification/notification.service';
import { GlobalEventServiceService, GlobalEventType } from '@services/global-event-service.service';
import { StateService } from '@services/state.service';
import { ToolbarService } from '@toolbar/toolbar.service';
import { dateToStr, isValidDate, subtractDate } from '@util/date-utils';
import { selectOptionById } from '@util/input-utils';
import { ensureArray, forEach, isJsObject, parseDec } from '@util/utils';
import { setTopElementSize, setWrapperElementSize } from '@util/visual-utils';
import { getClientRect } from '@util/web-utils';
//import * as moment from 'moment';
import { interval, Subscription } from 'rxjs';
import { first } from 'rxjs/operators';
import { OrderEventType } from '../order-events';
import { getSortFunction, getSortTypes } from './print-receipts.util';
import { ViewDocumentDialogComponent } from '../view/view-document-dialog/view-document-dialog.component';


const enum RECEIPT_EVENT_TYPES {
  SELECT_SINGLE = 'select_receipt',
  SELECT_ALL_TO_CHECKBOX = 'receipt_select_all_checkbox',
  SELECT_ALL_FROM_DIALOG = 'receipt_select_all_dialog'

}
function getAssignColumn(id: any) {
  return {
    width: 80,
    cellRenderer: CheckboxCellRendererComponent,
    cellRendererParams: {
      eventName: RECEIPT_EVENT_TYPES.SELECT_SINGLE,
      headerId: id,
      headerEventName: RECEIPT_EVENT_TYPES.SELECT_ALL_FROM_DIALOG,
      callbackEventName:RECEIPT_EVENT_TYPES.SELECT_ALL_TO_CHECKBOX,
      headerChecked:true
    },
    headerComponent: CheckboxHeaderCellRendererComponent,
    pinned: 'left',
    headerName: ''
  };
}

const orderNrColumn = {
  field: 'id',
  headerName: 'Auftrag',
  width: 80,
  cellClass: GridColumnStyles.CELL_CLASS_INT,
  /*
  cellRenderer: (params: any) => {
    //console.log('P:', params);
    const cls = '';//params.data.doc_state ? 'cell-green' : 'cell-red';
    // put the value in bold
    return '<span class="' + cls + '">' + params.value + '</span>';
  }
  */
};

const dateColumn = {
  field: 'work_day',
  headerName: 'Datum',
  minWidth: 100
};

const licensePlateColumn = {
  field: 'plate',
  headerName: 'Kennzeichen',
  minWidth: 100
};

const customerColumn = {
  field: 'cname',
  headerName: 'Kunde',
  minWidth: 100
};

const partnerColumn = {
  field: 'pname',
  headerName: 'Partner',
  minWidth: 100
};

let receiptDialogId = 1;

function getReceiptDialogId() {
  receiptDialogId++;
  return receiptDialogId;
}


@Component({
  selector: 'app-print-receipts-dialog',
  templateUrl: './print-receipts-dialog.component.html'
})
export class PrintReceiptsDialogComponent implements OnInit {

  title = 'Quittungen zu einem Dokument zusammenfügen';

  startDate?: Date;

  endDate?: Date;

  dateChanged = false;

  placeholder = '';

  allSelected = false;

  fileName = '';

  files: any[] = [];

  selectById = selectOptionById;

  sortTypes: any = getSortTypes();

  btnClass = '';

  currentSortType: any;

  sortFC = new UntypedFormControl(null);

  dialogId = 1;

  isDialog = true;

  gridOptions: any = {
    headerHeight: 40,
    defaultColDef: {
      headerClass: 'def-col',
      autoHeight: true,
      cellClass: GridColumnStyles.CELL_CLASS_STRING
    },
    columnDefs: [
      getAssignColumn(1),
      orderNrColumn,
      dateColumn,
      licensePlateColumn,
      customerColumn,
      partnerColumn
    ],
    enableCellTextSelection: true,
    alwaysShowHorizontalScroll: true,
    alwaysShowVerticalScroll: true,
    getRowStyle,
  };

  eventSub!: Subscription;
  sortSub!: Subscription;
  isAdmin = false;
  public dialogData: any;

  elSub?: Subscription | null = null;

  protected _docWrapper?: ElementRef;
  @ViewChild('docwrapper') set docwrapper1(wrap: ElementRef) {
    this._docWrapper = wrap;
    wrap && this.updateHeights();
  }

  protected _docButtons?: ElementRef;
  @ViewChild('docbuttons') set docButtons1(wrap: ElementRef) {
    this._docButtons = wrap;
    wrap && this.updateHeights();
  }

  protected _docTable?: ElementRef;
  @ViewChild('doctable') set docTable1(wrap: ElementRef) {
    this._docTable = wrap;
    wrap && this.updateHeights();
  }

  clearElSub() {
    this.elSub && this.elSub.unsubscribe();
    this.elSub = null;
  }

  createPosWatcher(checkFn: () => boolean) {
    return interval(50).pipe(first((value: number) => {
      return checkFn();
    }));
  }

  updateHeights() {
    const ne = (elem?: ElementRef) => {
      return elem?.nativeElement;
    };
    this.elSub = this.createPosWatcher(() => {
      const r1 = getClientRect(ne(this._docWrapper));
      const el2 = ne(this._docTable);
      const r3 = getClientRect(ne(this._docButtons));
      if (r1 && el2 && r3) {
        return r1.top > 0 && r3.height > 0;
      }
      return false;
    }).subscribe(() => {
      const bottomOffset = 16;
      setWrapperElementSize(
        ne(this._docWrapper),
        bottomOffset
      );
      setTopElementSize(
        ne(this._docWrapper),
        ne(this._docTable),
        ne(this._docButtons),
        bottomOffset
      );
      this.elSub?.unsubscribe();
      this.elSub = null;
    });
  }

  docPadding = 0;

  constructor(
    injector: Injector,
    @Optional() public dialogRef: MatDialogRef<PrintReceiptsDialogComponent>,
    //@Optional() @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private dataService: DataService,
    public matDialog: MatDialog,
    private notificationService: NotificationService,
    private eventService: GlobalEventServiceService,
    private toolbarService: ToolbarService,
    stateService: StateService
  ) {
    this.isDialog = isJsObject(dialogRef);

    if (this.isDialog) {
      this.dialogData = injector.get(MAT_DIALOG_DATA);
    }

    this.dialogId = getReceiptDialogId();

    this.gridOptions.columnDefs[0] = getAssignColumn(this.dialogId);

    this.isAdmin = !!stateService.isAdmin();
  }

  ngOnInit(): void {
    MyLog.log('Receipts:dialog:', this.isDialog);
    const ed = new Date();
    //const m = moment(ed, true);
    //const m2 = m.subtract('2', 'weeks');
    const sd = subtractDate(ed, 2, 'weeks');// m2.toDate();
    this.startDate = sd;
    this.endDate = ed;
    this.updatePlaceholder(true);

    if (!this.isDialog) {

      this.toolbarService.setTitle(this.title);
    }

    this.eventSub = this.eventService
      .listen()
      .subscribe((evt: GlobalEventType) => {
        if (isJsObject(evt) && isJsObject(evt.data)) {
          switch (evt.type) {
            case RECEIPT_EVENT_TYPES.SELECT_SINGLE:
              this.selectDocument(evt.data, evt.data.item);
              this.clearDownload();
              break;
            case RECEIPT_EVENT_TYPES.SELECT_ALL_FROM_DIALOG:
              this.selectAllDocuments(evt.data);
              break;
          }

        }
      });

    this.currentSortType = this.sortTypes[0];

    this.sortFC.setValue(this.currentSortType);

    this.sortSub = this.sortFC.valueChanges.subscribe((entry: any) => {
      if (this.currentSortType !== entry && entry && entry.id) {
        this.currentSortType = entry;
        this.clearDownload();
        this.doSort();
      }
    });

    if (this.isDialog) {
      this.btnClass = 'print-receipts-buttons-dialog';
    } else {
      this.btnClass = 'print-receipts-buttons-route';
    }
  }

  sendAllSelectedEvent(checked:boolean) {
    this.eventService.sendEvent(
      RECEIPT_EVENT_TYPES.SELECT_ALL_TO_CHECKBOX,
      {
      headerId: this.dialogId,
      checked: checked
    });
  }

  ngOnDestroy(): void {
    this.eventSub.unsubscribe();
    this.sortSub.unsubscribe();
  }

  updateGrid() {
    if (this.isDialog) {
      this._grid && this._grid.setRowData(this.files);
    } else {
      //console.error('TODO:Component table');
    }
  }

  public _grid!: OrdersGridComponent;
  @ViewChild('grid', {
    read: OrdersGridComponent
  }) set grid(grid: OrdersGridComponent) {
    this.setGrid(grid);
  }

  setGrid(grid: OrdersGridComponent) {
    this._grid = grid;
    this.updateGridOptions();
    this.updateGrid();
  }

  updateGridOptions() {
    if (this._grid) {
      this._grid.setGridOptions(this.gridOptions);
    }
  }


  onStartDateChange($event: any) {
    this.startDate = this.onDateChange($event);
    MyLog.log('New:SD:', this.startDate);
    this.updatePlaceholder();
  }

  onEndDateChange($event: any) {
    this.endDate = this.onDateChange($event);
    MyLog.log('New:ED:', this.endDate);
    this.updatePlaceholder();
  }

  onDateChange($event: any) {
    this.dateChanged = true;
    return $event && isValidDate($event) ? $event : null;
  }

  updatePlaceholder(updateText = false) {
    let sd = '', ed = '';
    if (this.startDate) {
      sd = dateToStr(this.startDate);
    }
    if (this.endDate) {
      ed = dateToStr(this.endDate);
    }
    let txt = 'Zusammenfassung_Quittungen_';
    if (sd) {
      if (ed) {
        txt += sd + '-' + ed;
      } else {
        txt += 'ab_' + sd;
      }
    } else if (ed) {
      txt += 'bis_' + ed;
    }
    const today = dateToStr(new Date());
    txt += '_vom_' + today;
    this.placeholder = txt;

    if (updateText) {
      this.fileName = txt;
    }
  }

  doSort() {
    let sortFn = getSortFunction(this.currentSortType?.id);
    if (sortFn) {
      const res = ensureArray(this.files).slice();
      res.sort(sortFn);
      this.files = res;
      this.updateGrid();
    } else {
      this.notificationService.showErrors([
        'Fehler bei Sortierung'
      ]);
    }
  }

  close() {
    this.dialogRef.close(null);
  }

  onFilterChange($event: any) {

  }

  search() {
    this.onFilterClickChange({
      from: this.startDate,
      to: this.endDate
    });
  }

  onFilterClickChange($event: any) {
    this.clearDownload();
    MyLog.log('PRD:search:', $event);
    const url = '/montage/receipts/';
    let queryParams: any = {};

    if ($event) {
      if ($event.from) {
        this.onStartDateChange($event.from);

        let sd = dateToStr($event.from);
        if (sd) {
          queryParams.from = sd;
        }
      }
      if ($event.to) {
        this.onEndDateChange($event.to);

        let ed = dateToStr($event.to);
        if (ed) {
          queryParams.to = ed;
        }
      }
    }

    const toName = (item: any) => {
      return item.first_name + ' ' + item.last_name;
    };

    this.dataService.get(url, queryParams).subscribe((res: any) => {
      MyLog.log('GOT:', res);
      const result = res?.result;
      if (result?.success) {
        if (Array.isArray(result.files)) {
          this.files = result.files;

          forEach(this.files, (item: any) => {
            if (item.customer) {
              item.cname = toName(item.customer);
            }
            if (item.partner) {
              item.pname = toName(item.partner);
            }

            if (typeof item.work_day === 'string') {
              const p = item.work_day.split('-');
              if (p.length) {
                item.work_day = [p[2], p[1], p[0]].join('.');
                let y = parseDec(p[0]);
                let m = parseDec(p[1]);
                let d = parseDec(p[2]);

                if (Number.isFinite(d) && Number.isFinite(m) && Number.isFinite(y)) {
                  item.wd = y * 1000 + m * 100 + d;
                }
              }
            }
          });
          this.doSort();

          this.selectAllDocuments({
            checked: true
          });

          this.updateGrid();
        }
      }
    });
  }

  isGeneratingFile = false;

  save() {
    this.clearDownload();

    const ids = this.files.filter((item: any) => {
      return item.selected;
    }).map((item: any) => { return item.id; });

    let fn = this.fileName.trim();
    if (!fn) {
      fn = this.placeholder;
    }

    if (!ids.length) {
      this.notificationService.showErrors([
        'Keine Dokumente ausgewählt'
      ]);
      return;
    }

    const requestData: any = {
      ids: ids,
      type: 'receipts',
      filename: this.fileName
    };
    const url = '/montage/receipts';

    const downloadFilename = this.fileName + '.pdf';

    this.isGeneratingFile = true;

    this.dataService.postAndDownload(url, requestData, {
      headers: {}
    }).subscribe((res: any) => {

      this.isGeneratingFile = false;

      if (res.download) {
        this.eventService.sendEvent(
          OrderEventType.RECEIPTS_GENERATED,
          {}
        );
        this.setLinkForDownload(res, downloadFilename);
        return;
      }

      const result = res?.result;

      if (result?.success) {
        const msg = result.msg || 'Datei erfolgreich erzeugt';
        this.notificationService.showSuccess(msg);
        this.dialogRef.close({
          docId: result.id
        });
      } else {
        const errors: any = [];
        if (result?.error) {
          errors.push(result?.error);
        } else {
          errors.push('Unbekannter Fehler beim Erzeugen der Datei');
        }

        this.notificationService.showErrors(errors);
      }
    });
  }

  downloadLink = '';

  clearDownload() {
    this.downloadLink = '';
  }

  setLinkForDownload(res: any, fileName: string) {

    let msg = 'Download wird gestartet.';
    if (res.headers) {
      if (res.headers.fileName) {
        fileName = fileName;
      }
      if (res.headers.link) {
        this.downloadLink = res.headers.link;
        msg += '.Wenn nicht, so klicken Sie auf den Download-Link'
      }
    }

    this.notificationService.showSuccess(msg);
    /*
    const url = window.URL.createObjectURL(res);
    window.open(url)
    */
    //const url = window.URL.createObjectURL(res);
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(res.blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  selectAllDocuments($event: any) {
    if (isJsObject($event)) {
      this.allSelected = $event.checked;

      this.files.forEach((item: any) => {
        item.selected = this.allSelected;
      });

      this.sendAllSelectedEvent(this.allSelected);
    }

    this.clearDownload();
  }

  selectDocument($event: any, item: any) {
    if (isJsObject($event) && isJsObject(item)) {
      item.selected = $event.checked;
      this.clearDownload();

      this.allSelected = this.files.every((e:any)=> {
        return !!e.selected;
      });

      this.sendAllSelectedEvent(this.allSelected);
    }
  }


  onViewClick(data:any ){

    this.matDialog.open(ViewDocumentDialogComponent, {
      data: {
        order: data
      },
      panelClass: 'my-dialog-panel',
      position: {
        top: '5vh',
      },
      width: '96vw',
      minWidth: '96vw',
      height: '93vh',
    });
  }
}
